/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The postal address and some additional data.   (bipro-partner::Partneranschrift)
 */
export interface PartnerAddress {
  street?: string;
  houseNumber?: string;
  postCode?: string;
  city?: string;
  /**
   * Country code with two characters according to ISO-3166-1 Alpha 2.
   */
  countryCode?: string;
  /**
   * Additional information, e.g. \"z. Hd.\", \"c/o\", \"Lagerhalle 42\".   (german: Adresszusatz)
   */
  addressExtension?: string;
  /**
   * In case of multiple address per partner, this may indicate the preferred postal address.  Otherwise always the first address is used.   (german: bevorzugte Postadresse)
   */
  preferredPostalAddress?: boolean;
}
